import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43cbe8f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "on-monitor" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/public/logo.png",
  alt: "LOGO"
}, null, -1))
const _hoisted_5 = { class: "menu-list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "product-serve"
}
const _hoisted_8 = { class: "product" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "八爪畅学用户端", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "孩子的素质教育成长营", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "八爪畅学机构端", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "机构的专属招生和运营平台", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "八爪优服", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "服务商营销生态系统", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "on-mobile" }
const _hoisted_22 = { class: "head-part" }
const _hoisted_23 = { class: "container" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/public/logo.png",
  class: "logo"
}, null, -1))

import { useRouter } from "vue-router";
    import { ref, onMounted, onUnmounted, computed } from 'vue';
    import { useStore } from "vuex";
    import { key } from "../store";
    import { menus } from "@/utils/global";
    interface settledConfig {
        flag: boolean;
        type: number;
    }
    
export default /*#__PURE__*/_defineComponent({
  __name: 'BaseHeader',
  setup(__props) {

    // 引入useRouter
    let store = useStore(key);
    
    // 在计算属性中获取当前的菜单id
    let menuid = computed(()=>{
        return store.state.menuid
    }) 

    // 目录点击跳转路由事件
    const router = useRouter();
    // channel渠道 10 直推 20 直进 30 官网 40 电销二维码 50 合伙人二维码 60 招商会二维码 70 微信公众号 80 宣传物料
    const toPage = (id: string) => {
        switch(id){
            case "1":
                router.push({ path: "/" });
                break;
            case "2":
                break;
            case "3":
                router.push({ name: "newsList" });
                break;
            case "4": // 机构入驻
                settledActive({ flag:true, type:1 })
                break;
            case "5": // 服务商入驻
                settledActive({ flag:true, type:2 })
                break;
            default:
                break;
        }
    }

    // PC端-入驻
    const settledActive = (obj:settledConfig)=>{
        store.commit("settledActive",obj);
    }

    // 产品服务下的三个页面
    const targetProduct = (type:number)=>{
        switch(type){
            case 1:
                router.push({ name: "consumer" });
                break;
            case 2:
                router.push({ name: "mechanism" });
                break;
            case 3:
                router.push({ name: "serve" });
                break;
            default:
                break;
        }
    }
    let hasbackFlag = ref(false);
    let backTopFlag = ref(false); //用来判断样式
    const backTop = () => {
      let top = document.documentElement.scrollTop; //获取点击时页面的滚动条纵坐标位置
      const timeTop = setInterval(() => {
        document.documentElement.scrollTop = top -= 50; //一次减50往上滑动
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 5)//定时调用函数使其更顺滑
    }
    const handleScroll = () => {
        // 向下滑动，显示固定头部底色
        hasbackFlag.value = document.documentElement.scrollTop > 0;
        // 滑动超过一屏，显示返回按钮
        backTopFlag.value = document.documentElement.scrollTop > document.documentElement.clientHeight;
    }

    // 移动端-显示菜单
    const menuPhoneActive = (flag:boolean)=>{
        store.commit("menuPhoneShow",flag);
    }

    onMounted(() => {
        window.addEventListener('scroll', handleScroll);
    })
    //监听滚动事件
    onUnmounted(() => {
        //离开页面时移除监听事件
        window.removeEventListener('scroll', handleScroll);
    })


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("main", {
        class: _normalizeClass(["head-part", {hasback: _unref(hasbackFlag)}])
      }, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("aside", _hoisted_3, [
            _createVNode(_component_router_link, { to: {path:'/'} }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menus), (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: _normalizeClass([_unref(menuid) === item.id ? 'active' : '']),
                onClick: _withModifiers(($event: any) => (toPage(item.id)), ["stop"])
              }, [
                (item.id === '2')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _createTextVNode(" 产品服务 "),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", {
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (targetProduct(1)), ["stop"]))
                          }, _hoisted_11),
                          _hoisted_12,
                          _createElementVNode("li", {
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (targetProduct(2)), ["stop"]))
                          }, _hoisted_15),
                          _hoisted_16,
                          _createElementVNode("li", {
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (targetProduct(3)), ["stop"]))
                          }, _hoisted_19)
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(item.title), 1))
              ], 10, _hoisted_6))
            }), 128))
          ])
        ])
      ], 2),
      (_unref(backTopFlag))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "back-top",
            onClick: backTop
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("header", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("section", _hoisted_23, [
          _createVNode(_component_router_link, { to: {path:'/'} }, {
            default: _withCtx(() => [
              _hoisted_24
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            class: "menu-svg",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (menuPhoneActive(true)))
          })
        ])
      ])
    ])
  ], 64))
}
}

})